import BookingSummary from '@/components/booking/Summary'
import { API } from '@/modules/api'

export function init () {
  const root = document.querySelector('.booking-summary')

  if (root) {
    const data = new API().getBookingSummaryStaticData(root.id)
    new BookingSummary({ el: root, propsData: { data } })
  }
}


// WEBPACK FOOTER //
// ./src/modules/bookingSummary.js